import { stats } from '@/mocks/home';

type HeroProps = {
  query: string;
  onQueryChange: (value: string) => void;
};

const quickEntries = [
  { label: '娱乐八卦', icon: 'ri-vip-crown-line' },
  { label: '职场爆料', icon: 'ri-briefcase-line' },
  { label: '探店避雷', icon: 'ri-store-2-line' },
  { label: '校园圈', icon: 'ri-graduation-cap-line' },
];

export default function Hero({ query, onQueryChange }: HeroProps) {
  return (
    <section id="top" className="relative overflow-hidden pt-28 pb-14 md:pt-36 md:pb-20">
      <div className="pointer-events-none absolute -right-24 top-10 h-72 w-72 rounded-full bg-primary-100/60 blur-2xl"></div>
      <div className="pointer-events-none absolute -left-24 bottom-0 h-64 w-64 rounded-full bg-accent-100/50 blur-2xl"></div>

      <div className="relative mx-auto grid max-w-[1200px] grid-cols-1 items-center gap-10 px-4 md:px-6 lg:grid-cols-[1.15fr_0.85fr] lg:gap-14">
        <div className="animate-fade-up">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-300 bg-accent-50 px-3 py-1 text-xs font-medium text-accent-800">
            <i className="ri-links-line text-sm"></i>
            栏目 · 专题 · 标签 三层导航
          </span>

          <h1 className="mt-5 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-5xl">
            黑料网1
            <span className="block text-2xl font-semibold text-primary-600 md:mt-2 md:text-3xl">
              栏目分类导航，按专题与标签直接进
            </span>
          </h1>

          <p className="mt-5 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
            黑料网1栏目分类清晰，按专题、标签、目录划分不同板块，想找特定类型的料直接按分类进。
            黑料网1板块导航一目了然，快速定位你感兴趣的栏目——不用在信息流里翻，从目录直接落到你想看的那一段。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
            <div className="flex flex-1 items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3 py-2.5 sm:max-w-sm">
              <span className="flex h-5 w-5 items-center justify-center text-foreground-400">
                <i className="ri-search-line text-base"></i>
              </span>
              <input
                type="text"
                value={query}
                onChange={(e) => onQueryChange(e.target.value)}
                placeholder="搜索栏目或标签，如「职场」「北京」"
                className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
              />
              {query && (
                <button
                  type="button"
                  aria-label="清空搜索"
                  onClick={() => onQueryChange('')}
                  className="flex h-5 w-5 cursor-pointer items-center justify-center text-foreground-400 hover:text-foreground-700"
                >
                  <i className="ri-close-circle-line text-base"></i>
                </button>
              )}
            </div>
            <a
              href="#category"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-compass-3-line text-base"></i>
              开始按栏目找
            </a>
          </div>

          <div className="mt-7 flex flex-wrap gap-2">
            {quickEntries.map((entry) => (
              <a
                key={entry.label}
                href="#category"
                className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-background-300 bg-background-100 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                <i className={`${entry.icon} text-sm`}></i>
                {entry.label}
              </a>
            ))}
          </div>

          <dl className="mt-9 grid grid-cols-2 gap-4 border-t border-background-200 pt-6 sm:grid-cols-4">
            {stats.map((item) => (
              <div key={item.label}>
                <dt className="text-xs text-foreground-500">{item.label}</dt>
                <dd className="mt-1 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                  {item.value}
                </dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="animate-fade-up lg:justify-self-end" style={{ animationDelay: '120ms' }}>
          <div className="relative w-full max-w-md overflow-hidden rounded-lg border border-background-200 bg-background-100">
            <div className="relative h-56 w-full md:h-64">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20warm%20amber%20and%20cream%20paper%20texture%20background%20with%20subtle%20geometric%20grid%20lines%2C%20soft%20grain%2C%20minimal%20editorial%20art%20direction%2C%20calm%20and%20tidy%20composition%2C%20no%20text&width=900&height=640&seq=heila-hero-abstract-01&orientation=landscape"
                alt="黑料网1 栏目分类导航结构示意"
                title="黑料网1 栏目分类导航"
                className="h-full w-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/20 to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <p className="text-xs text-background-100/90">目录结构示例</p>
                <p className="mt-1 font-heading text-base font-semibold text-background-50">
                  从栏目进 → 用专题看脉络 → 靠标签筛选
                </p>
              </div>
            </div>

            <div className="divide-y divide-background-200">
              {[
                { icon: 'ri-list-check-2', title: '栏目导航', desc: '8 个分类方向' },
                { icon: 'ri-stack-line', title: '专题板块', desc: '24 个话题合集' },
                { icon: 'ri-price-tag-3-line', title: '标签目录', desc: '5 组筛选维度' },
              ].map((row) => (
                <a
                  key={row.title}
                  href={row.title === '栏目导航' ? '#category' : row.title === '专题板块' ? '#topic' : '#tags'}
                  className="flex items-center gap-3 px-4 py-3 transition-colors hover:bg-background-50"
                >
                  <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                    <i className={`${row.icon} text-base`}></i>
                  </span>
                  <span className="flex-1">
                    <span className="block text-sm font-medium text-foreground-900">{row.title}</span>
                    <span className="block text-xs text-foreground-500">{row.desc}</span>
                  </span>
                  <span className="flex h-5 w-5 items-center justify-center text-foreground-400">
                    <i className="ri-arrow-right-s-line text-lg"></i>
                  </span>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}